import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import React from 'react';

import { getDisplayName } from '@swf/core/utils';

import WizardGroup from '../WizardGroup/WizardGroup';

import SignupBlockedCountry from './components/SignupBlockedCountry/SignupBlockedCountry';
import SignupCAONRedirect from './components/SignupCAONRedirect/SignupCAONRedirect';
import SignupConsent from './components/SignupConsent/SignupConsent';
import SignupCountry from './components/SignupCountry/SignupCountry';
import SignupEmail from './components/SignupEmail/SignupEmail';
import SignupLegal from './components/SignupLegal/SignupLegal';
import SignupOffer from './components/SignupOffer/SignupOffer';
import SignupPIN from './components/SignupPIN/SignupPIN';
import SignupPassword from './components/SignupPassword/SignupPassword';
import SignupUsername from './components/SignupUsername/SignupUsername';
import SingleScreenSignUp from './components/SingleScreenSignUp/SingleScreenSignUp';
import useSignUpFlow from './hooks/useSignUpFlow';
import useSignupGuards from './hooks/useSignupGuards';
import useSignupServices from './hooks/useSignupServices';

const Signup: React.FC = () => {
  const flow = useSignUpFlow();
  const guards = useSignupGuards();
  const services = useSignupServices();

  return (
    <TrackingContext.Provider value={{ category: TrackingCategory.Signup }}>
      <WizardGroup name={getDisplayName(Signup)} flow={flow} services={services} guards={guards}>
        <SignupCountry />
        <SignupCAONRedirect />
        <SignupConsent />
        <SignupBlockedCountry />
        <SignupUsername />
        <SignupPassword />
        <SignupEmail />
        <SignupPIN />
        <SignupLegal />
        <SignupOffer />
        <SingleScreenSignUp />
      </WizardGroup>
    </TrackingContext.Provider>
  );
};

Signup.displayName = 'Signup';

export default Signup;
